<template>
  <div class="main-wrapper">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
      <a class="navbar-brand js-scroll-trigger" @click="scrollToTop()">
        <span class="d-block d-lg-none">{{ firstname }} {{ lastname }}</span>
        <span class="d-none d-lg-block">
          <img
            class="img-fluid img-profile rounded-circle mx-auto mb-2"
            :src="toBase('/static/img/profile.jpg')"
            :alt="firstname + ' ' + lastname">
        </span>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul v-if="['home'].indexOf($route.name) > -1" class="navbar-nav" v-scroll-spy-active v-scroll-spy-link>
          <li class="nav-item d-none">
            <router-link class="nav-link" :to="{ path: '/', hash:'#page-top' }" id="goToTop">Me</router-link>
          </li>
          <li v-for="item in navItems" :key="item.hash" class="nav-item">
            <router-link class="nav-link" :to="{ path: item.path, hash: item.hash }">{{ item.name }}</router-link>
          </li>
        </ul>
        <ul v-else class="navbar-nav">
          <li class="nav-item d-none">
            <router-link class="nav-link" :to="{ path: '/', hash:'#page-top' }" id="goToTop">Me</router-link>
          </li>
          <li v-for="item in navItems" :key="item.hash" class="nav-item">
            <router-link class="nav-link" :to="{ path: item.path, hash: item.hash }">{{ item.name }}</router-link>
          </li>
        </ul>
      </div>
    </nav>

    <slot />

    <custom-footer />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { scrollTo, scrollToTop } from '@/utils/utils.js'

import Footer from '@/components/Footer'

export default {

  components: {
    'custom-footer': Footer
  },

  data () {
    return {
      firstname: undefined,
      lastname: undefined,
      navItems: [
        { path: '/', hash: '#about', name: 'About Me' },
        { path: '/', hash: '#teaching', name: 'Teaching' },
        { path: '/', hash: '#students', name: 'Students' },
        { path: '/', hash: '#projects', name: 'Projects' },
        { path: '/', hash: '#publications', name: 'Publications' }
      ]
    }
  },

  computed: {
    ...mapState(['$profile']),
    ...mapGetters(['toBase'])
  },

  mounted () {
    this.fetchProfile()

    this.$nextTick(() => this.scrollTo(this.$route.hash))
  },

  methods: {
    scrollTo,
    scrollToTop,
    fetchProfile () {
      /* this.increase$loading()
      fetch('/api/profile')
        .then(stream => stream.json())
        .then(data => { this.firstname = data.firstname; this.lastname = data.lastname })
        .then(() => { this.decrease$loading() })
        .catch(error => { this.decrease$loading(); console.error(error) }) */
      this.firstname = this.$profile.firstname
      this.lastname = this.$profile.lastname
    }
  }
}
</script>

<style lang="scss">
@import '../../node_modules/bootstrap/scss/bootstrap.scss';
@import '@/styles/_app.scss';
</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue